import React from 'react'
import VariantSelector from '../components/VariantSelector';
import {withRouter} from "react-router-dom";
import NumberFormat from 'react-number-format';

class Product extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.state.product = this.props.product;

    if(!this.state.product) {
      this.props.client.product.fetchByHandle(this.props.match.params.slug).then((product) => {
        this.setState({product: product})
      });
    }
  }

  buyButton(product, variant, variantQuantity) {
    if (product.availableForSale) {
      return (
        <button className="Product__buy button" onClick={() => this.props.addVariantToCart(variant.id, variantQuantity)}>Add to Cart</button>
      );
    } else {
      return (
        <button className="Product__buy button" disabled={true}>Sold out</button>
      );
    }
  }

  render() {
    let product = this.state.product;
    

    if (product) {
      let variantImage = this.state.selectedVariantImage || this.state.product.images[0]
      let variant = this.state.selectedVariant || this.state.product.variants[0]
      let variantQuantity = this.state.selectedVariantQuantity || 1
      let variantSelectors = this.state.product.options.map((option) => {
        return (
          <VariantSelector
            handleOptionChange={this.handleOptionChange}
            key={option.id.toString()}
            option={option}
          />
        );
      });

      return (
        <div className='body-container'>
          <img className='product-image' src={product.images[0].src} />
         
          <div className="product-header">
            <h5 className="Product__title">{product.title}</h5>
            <div><NumberFormat decimalScale={0} displayType='text' thousandSeparator={true} prefix={'$'} value={variant.priceV2.amount}/></div>
          </div>
          <div className="product-content-main">
            <div className="product-checkout-options">
              {variantSelectors}
              <div className="product-option"> 
                <label className="Product__option">
                  Quantity
                </label>
                <input min="1" type="number" defaultValue={variantQuantity} onChange={this.handleQuantityChange}></input>
              </div>
              {this.buyButton(product, variant, variantQuantity)}

            </div>
            <div className="product-description" dangerouslySetInnerHTML={{__html: product.descriptionHtml}}>
            </div>
          </div>
        </div>
      )
    } else {
      return (<div>loading...</div>)
    }
  }
}
export default withRouter(Product);


// WEBPACK FOOTER //
// ./src/routes/Product.js